import { useEffect } from 'react'

import { useLocation } from 'react-router'

import { DefaultSpacesSettings } from './DefaultSpacesSettings.js'
import { GeneralSettings } from './GeneralSettings.js'
import { HomepageSettings } from './HomepageSettings/HomepageSettings.js'
import { MediaSettings } from './MediaSettings.js'
import { OtherSettings } from './OtherSettings.js'
import { PermissionsSettings } from './PermissionsSettings.js'
import { PublishSettings } from './PublishSettings.js'
import { WhiteLabelSettings } from './WhiteLabelSettings/WhiteLabelSettings.js'

const AVAILABLE_ANCHORS = ['#publish', '#permissions', '#general-settings']

export const Settings = () => {
  const { hash } = useLocation()

  useEffect(() => {
    if (AVAILABLE_ANCHORS.includes(hash)) {
      const element = document.querySelector(hash)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [hash])

  return (
    <div className="flex flex-col space-y-5 max-w-3xl">
      <GeneralSettings />
      <PublishSettings />
      <PermissionsSettings />
      <HomepageSettings />
      <DefaultSpacesSettings />
      <MediaSettings />
      <WhiteLabelSettings />
      <OtherSettings />
    </div>
  )
}
